import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import t from "../utils/translate";

const LanguageSwitcher = ({ compact = false, iconOnly = false }) => {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, [open]);

  const chooseLanguage = (lang) => {
    setLanguage(lang);
    setOpen(false);
  };

  if (iconOnly) {
    return (
      <div className="happer-lang-icon" ref={wrapRef}>
        <button
          type="button"
          className="happer-icon-btn happer-lang-icon-btn"
          onClick={() => setOpen((prev) => !prev)}
          aria-label={t("language")}
          aria-expanded={open}
          aria-haspopup="menu"
        >
          <i className="fa fa-globe" aria-hidden="true" />
        </button>
        {open && (
          <div className="happer-lang-menu" role="menu">
            <button
              type="button"
              role="menuitem"
              className={language === "fr" ? "active" : ""}
              onClick={() => chooseLanguage("fr")}
            >
              {t("french")}
            </button>
            <button
              type="button"
              role="menuitem"
              className={language === "en" ? "active" : ""}
              onClick={() => chooseLanguage("en")}
            >
              {t("english")}
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`happer-lang-switch${compact ? " happer-lang-switch--compact" : ""}`}>
      {!compact && <p className="happer-lang-switch-label">{t("language")}</p>}
      <div className="happer-lang-switch-toggle" role="group" aria-label={t("language")}>
        <button
          type="button"
          className={language === "fr" ? "active" : ""}
          onClick={() => setLanguage("fr")}
        >
          {t("french")}
        </button>
        <button
          type="button"
          className={language === "en" ? "active" : ""}
          onClick={() => setLanguage("en")}
        >
          {t("english")}
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
